
      import { defu } from 'defu'
      const matcher = (m,p)=>{return [];}
      export default (path) => defu({}, ...matcher('', path).map(r => r.data).reverse())
      